import { Stack, TextField, Grid, Alert, InputAdornment, IconButton } from "@mui/material";
import React, { useRef, useState } from "react";
import { useContext } from "react";
import { useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { InventarioContext } from "../contexts";
import { useForm } from "../hooks";
import { isRequired } from "../hooks/useForm";
import ReactMarkdown from "react-markdown";
import rehypeRaw from "rehype-raw";
import { Box } from "@mui/system";
import { TableRowHtml } from "../components";
import { LoginTwoTone } from "@mui/icons-material";

const MagInventarioDettaglio = () => {

  const ModalitaFunzionamento_RiferimPalettaUbicazione = "RU";
  const ModalitaFunzionamento_ArticoloLotto = "AL";

  const { idInventario } = useParams();
  const inputRef = useRef();
  const inputRef2 = useRef();
  const quantitaRef = useRef();
  let navigate = useNavigate();
  const [columns, setColumns] = useState([]);

  const {
    state: { listRecord, displayText, customColumn, campiChiave, modalitaFunzionamento },
    getInventarioDetail,
    postRecordInventario,
  } = useContext(InventarioContext);

  useEffect(() => {
    if (idInventario) {
      getInventarioDetail(idInventario, navigate);
    }
  }, []);
  
  useEffect(() => {
    let colonne = [];
    if (idInventario && customColumn.length > 0) {
      customColumn.forEach((element) => {
        colonne = [
          ...colonne,
          {
            field: element.field,
            headerName: element.headerName,
            width: 300,
            /*   flex:1, */
          },
        ];
      });
      //colonne = [...colonne, colonnaStato];
      setColumns(colonne);
    }
  }, [customColumn]);

  /*  function CustomFooterStatusComponent() {
    return <></>;
  } */

  const validations = [
    // ({ Ubicazione }) =>
    //   (isRequired(Ubicazione) && (modalitaFunzionamento === undefined 
    //    || modalitaFunzionamento === "" 
    //    || modalitaFunzionamento === null 
    //    || modalitaFunzionamento === ModalitaFunzionamento_RiferimPalettaUbicazione )  )|| { RiferimPaletta: "*Ubicazione obbligatoria" },

    // ({ RiferimPaletta }) =>
    //   (isRequired(RiferimPaletta) && (modalitaFunzionamento === undefined 
    //      || modalitaFunzionamento === "" 
    //      || modalitaFunzionamento === null 
    //      || modalitaFunzionamento === ModalitaFunzionamento_RiferimPalettaUbicazione )  )|| { RiferimPaletta: "*Riferimento paletta obbligatorio" },
         
    // ({ Articolo }) =>
    //   (isRequired(Articolo) && ( modalitaFunzionamento === ModalitaFunzionamento_ArticoloLotto  )  )|| { Articolo: "*Articolo obbligatorio" },
    // ({ Lotto }) =>
    //   (isRequired(Lotto) && ( modalitaFunzionamento === ModalitaFunzionamento_ArticoloLotto  )  )|| { Lotto: "*Lotto obbligatorio" },
    // ({ Quantita }) =>
    //   (isRequired(Quantita) && ( modalitaFunzionamento === ModalitaFunzionamento_ArticoloLotto  )  )|| { Quantita: "*Quantità obbligatoria" },
  ];

  const {
    values: posizioneForm,
    changeHandler,
    touched,
    errors,
    isValid,
    setValues,
  } = useForm(
    {
      RiferimPaletta : "",
      Ubicazione     : "",
      Articolo       : "",
      Lotto          : "",
      Quantita       : 0
    },
    validations
  );

  

  const keyEnter = (event) => {
    if (event === 13) {
      const timeout = setTimeout(() => {
        inputRef.current.focus();
      }, 100);

      return () => {
        clearTimeout(timeout);
      };
    }
  };


  
  const keyEnter_lotto = (event) => {
    if (event === 13) {
      const timeout = setTimeout(() => {
        quantitaRef.current.focus();
      }, 100);

      return () => {
        clearTimeout(timeout);
      };
    }
  };

  const onkeyEnter = (event) => {
    if (event === 13) {
      if (isValid) {
        let data = {
          PrgMovimento   : campiChiave.PrgMovimento,
          RiferimPaletta : posizioneForm.RiferimPaletta,
          Ubicazione     : posizioneForm.Ubicazione,
          Articolo       : posizioneForm.Articolo,
          Lotto          : posizioneForm.Lotto,
          Quantita       : posizioneForm.Quantita
        };
        postRecordInventario(data, idInventario);
        //getRefreshListaInventario(idInventario)
        setValues({
          RiferimPaletta: "",
          Ubicazione: "",
        });
        const timeout = setTimeout(() => {
          inputRef2.current.focus();
        }, 100);

        return () => {
          clearTimeout(timeout);
        };
      }
    }
  };


  const onkeyEnter_manual = (event) => {

      if (isValid) {
        let data = {
          PrgMovimento   : campiChiave.PrgMovimento,
          RiferimPaletta : posizioneForm.RiferimPaletta,
          Ubicazione     : posizioneForm.Ubicazione,
          Articolo       : posizioneForm.Articolo,
          Lotto          : posizioneForm.Lotto,
          Quantita       : posizioneForm.Quantita
        };
        postRecordInventario(data, idInventario);
        //getRefreshListaInventario(idInventario)
        setValues({
          RiferimPaletta: "",
          Ubicazione: "",
        });
        const timeout = setTimeout(() => {
          inputRef2.current.focus();
        }, 100);

        return () => {
          clearTimeout(timeout);
        };
      }

  };

  console.log("modalitaFunzionamento", modalitaFunzionamento)

  return (
    <Grid container>
      { modalitaFunzionamento === undefined 
        || modalitaFunzionamento === "" 
        || modalitaFunzionamento === null 
        || modalitaFunzionamento === ModalitaFunzionamento_RiferimPalettaUbicazione ? 
      (
        <Grid
        container
          sx={{
            position: "fixed",
            background: (theme) => theme.palette.background.paper,
          }}
          spacing={1}
        >
          <Grid item xs={12} md={6} lg={6}>
            <TextField
              id="outlined-basic41"
              label="Riferimento paletta"
              variant="outlined"
              placeholder="Inserire il barcode"
              fullWidth
              size="small"
              inputRef={inputRef2}
              autoFocus
              autoComplete={"off"}
              value={posizioneForm.RiferimPaletta || ""}
              onKeyPress={(e) => keyEnter(e.charCode)}
              onChange={(e) => changeHandler("RiferimPaletta", e.target.value)}
            />
          </Grid>
          <Grid item xs={12} md={6} lg={6}>
            <TextField
              id="outlined-basi4c"
              label="Ubicazione"
              variant="outlined"
              size="small"
              placeholder="Inserire ubicazione"
              error={Boolean(touched.Ubicazione && errors.Ubicazione)}
              helperText={touched.Ubicazione && errors.Ubicazione}
              fullWidth
              inputRef={inputRef}
              autoComplete={"off"}
              onKeyPress={(e) => onkeyEnter(e.charCode)}
              value={posizioneForm.Ubicazione || ""}
              onChange={(e) => changeHandler("Ubicazione", e.target.value)}
              InputProps={{
                endAdornment: (
                  <InputAdornment position="end">
                    <IconButton
                      color="primary"
                      disabled={!isValid}
                      onClick={() => onkeyEnter_manual()} 
                    >
                      <LoginTwoTone />
                    </IconButton>
                  </InputAdornment>
                ),
              }}
            />
          </Grid>
        </Grid>
      ):(
        <></>
      )}

    {   
        modalitaFunzionamento === ModalitaFunzionamento_ArticoloLotto ? 
      (
        <Grid
        container
          sx={{
            position: "fixed",
            background: (theme) => theme.palette.background.paper,
          }}
          spacing={1}
        >
          <Grid item xs={12} md={6} lg={6}>
            <TextField
              id="outlined-basic41"
              label="Articolo"
              variant="outlined"
              placeholder="Inserire il barcode"
              fullWidth
              size="small"
              inputRef={inputRef2}
              autoFocus
              autoComplete={"off"}
              value={posizioneForm.Articolo || ""}
              onKeyPress={(e) => keyEnter(e.charCode)}
              onChange={(e) => changeHandler("Articolo", e.target.value)}
            />
          </Grid>
          <Grid item xs={12} md={6} lg={6}>
            <TextField
              id="outlined-basi4c"
              label="Lotto"
              variant="outlined"
              size="small"
              placeholder="Inserire lotto"
              error={Boolean(touched.Lotto && errors.Lotto)}
              helperText={touched.Lotto && errors.Lotto}
              fullWidth
              inputRef={inputRef}
              autoComplete={"off"}
              onKeyPress={(e) => keyEnter_lotto(e.charCode)}
              value={posizioneForm.Lotto || ""}
              onChange={(e) => changeHandler("Lotto", e.target.value)}
              
            />
          </Grid>

          

          <Grid item xs={12} md={4} lg={4}>
            <TextField 
              id="quantitaField"
              margin="normal"
              fullWidth
              size="small"
              label="Quantità"
              autoComplete="off"
              value={posizioneForm.Quantita || ""}
              inputRef={quantitaRef}
              //helperText={touched.FornitoreRagSoc && errors.FornitoreRagSoc}
              //error={Boolean(touched.FornitoreRagSoc && errors.FornitoreRagSoc)}
              onKeyPress={(e) => onkeyEnter(e.charCode)}
              onChange={(e) => changeHandler("Quantita", e.target.value)}
              InputProps={{
                endAdornment: (
                  <InputAdornment position="end">
                    <IconButton
                      color="primary"
                      disabled={!isValid}
                      onClick={() => onkeyEnter_manual()}
                    >
                      <LoginTwoTone />
                    </IconButton>
                  </InputAdornment>
                ),
              }}
            />
          </Grid>

        </Grid>
      ):(
        <></>
      )}


      <Grid container mt={10}>
        <Grid item xs={12} md={6} lg={6}>
          <Alert severity="info" icon={false}>
            {
              <ReactMarkdown
                children={displayText ? displayText : ""}
                rehypePlugins={[rehypeRaw]}
              ></ReactMarkdown>
            }{" "}
          </Alert>
        </Grid>
        <Grid item xs={12} md={12} lg={12}>
          {columns.length > 0 ? (
            <TableRowHtml customCol={columns} rows={listRecord} />
          ) : (
            <></>
          )}
        </Grid>
      </Grid>
    </Grid>
  );
};

export default MagInventarioDettaglio;
